import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { CardNumberInput } from './CardNumberInput';
import { ExpDateInput } from './ExpDateInput';
import { CvcInput } from './CvcInput';
import { useFormState } from 'react-hook-form';
import { useToggle } from 'react-use';
const CARD_NUMBER_FIELD = 'fullNumber';
const EXP_DATE_FIELD = 'expDate';
const CVC_FIELD = 'cvc';
const FORM_FIELDS = [CARD_NUMBER_FIELD, EXP_DATE_FIELD, CVC_FIELD];
export const CreditCardForm = ({ size, disabled, control, getValues }) => {
    const { errors } = useFormState({
        control
    });
    const [isCardNumberFocused, toggleIsCardNumberFocused] = useToggle(false);
    const [isExpDateFocused, toggleIsExpDateFocused] = useToggle(false);
    const [isCvcFocused, toggleIsCvcFocused] = useToggle(false);
    const formFieldsFocusStates = new Map([
        [CARD_NUMBER_FIELD, isCardNumberFocused],
        [EXP_DATE_FIELD, isExpDateFocused],
        [CVC_FIELD, isCvcFocused]
    ]);
    const cardNumFieldClassName = classNames('rounded-bl-none rounded-br-none relative focus:z-10', {
        'z-10': errors[CARD_NUMBER_FIELD]?.message
    });
    const expDateFieldClassName = classNames('rounded-tl-none rounded-r-none relative focus:z-10', {
        'z-10': errors[EXP_DATE_FIELD]?.message
    });
    const cvcFieldClassName = classNames('rounded-l-none rounded-tr-none relative focus:z-10', {
        'z-10': errors[CVC_FIELD]?.message
    });
    const labelClassName = classNames('mb-2 font-semibold', {
        'text-mBase md:text-base': !size,
        'text-base': size === 'md',
        'text-mBase': size === 'lg',
        'text-gray': disabled
    });
    const errorTextClassName = classNames('text-red mt-2', {
        'text-mSm md:text-base': !size,
        'text-base': size === 'md',
        'text-mSm': size === 'lg'
    });
    return (_jsxs("div", { className: "flex-wrap grow", children: [_jsx("p", { className: labelClassName, children: "Card information" }), _jsx("div", { className: "w-full relative", children: _jsx(CardNumberInput, { control: control, dataTestId: "card_number_field", disabled: disabled, inputClassName: cardNumFieldClassName, name: CARD_NUMBER_FIELD, size: size, onBlur: toggleIsCardNumberFocused, onFocus: toggleIsCardNumberFocused }) }), _jsxs("div", { className: "flex", children: [_jsx(ExpDateInput, { className: "w-1/2", control: control, dataTestId: "month_year", disabled: disabled, inputClassName: expDateFieldClassName, name: EXP_DATE_FIELD, size: size, onBlur: toggleIsExpDateFocused, onFocus: toggleIsExpDateFocused }), _jsx(CvcInput, { cardNumber: getValues('fullNumber'), className: "w-1/2", control: control, dataTestId: "cvc", disabled: disabled, inputClassName: cvcFieldClassName, name: CVC_FIELD, size: size, onBlur: toggleIsCvcFocused, onFocus: toggleIsCvcFocused })] }), Object.entries(errors)
                .filter(([key, value]) => FORM_FIELDS.includes(key) && !formFieldsFocusStates.get(value?.type + ''))
                .map(([key, value]) => typeof value?.message === 'string' && (_jsx("p", { className: errorTextClassName, children: value.message }, key)))] }));
};
